<template>
    <!-- Encabezado de la Aplicación -->
    <div class="appHeader">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            Metodos de Pagos
        </div>
        <div class="right">
            <a class="headerButton" data-bs-toggle="modal" data-bs-target="#addBankModal">
                <ion-icon name="add-outline"></ion-icon>
            </a>
            <a class="headerButton" @click="$root.toastbox('toast-example-1', 3000)">
                <ion-icon name="notifications-off-outline"></ion-icon>
            </a>
        </div>
    </div>
    <!-- * Encabezado de la Aplicación -->

    <!-- Toast inferior con icono -->
    <div id="toast-example-1" class="toast-box toast-bottom bg-primary">
        <div class="in">
            <ion-icon name="notifications-off-outline"></ion-icon>
            <div class="text">
                Los sonidos de notificación se han silenciado
            </div>
        </div>
        <button type="button" class="btn btn-sm btn-text-light close-button">OK</button>
    </div>
    <!-- * Toast inferior con icono -->

    <!-- Cápsula de la Aplicación -->
    <div id="appCapsule">

        <div class="section full">

            <ul class="listview image-listview flush">
                <li class="active-">
                    <a class="item">
                        <div class="icon-box bg-primary">
                            <ion-icon name="phone-portrait-outline"></ion-icon>
                        </div>
                        <div class="in">
                            <div>
                                <div class="mb-05"><strong>Nequi</strong></div>
                                <div class="text-small mb-05">Nombre del titular <b> NROIDENTY</b></div>
                                <div class="text-xsmall">300 000 0000</div>
                            </div>
                            <span class="badge badge-primary badge-empty"></span>
                        </div>
                    </a>
                </li>
                <li class="active-">
                    <a class="item">
                        <div class="icon-box bg-success">
                            <ion-icon name="wallet-outline"></ion-icon>
                        </div>
                        <div class="in">
                            <div>
                                <div class="mb-05"><strong>Bancolombia</strong></div>
                                <div class="text-small mb-05">Nombre del titular <b> NROIDENTY</b></div>
                                <div class="text-xsmall">NROCUENTA</div>
                            </div>
                            <span class="badge badge-primary">3</span>
                        </div>
                    </a>
                </li>
            </ul>

        </div>

    </div>
    <!-- * Cápsula de la Aplicación -->
    <default-button-menu />

    <div class="modal fade action-sheet" id="addBankModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Agregar banco</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <form-banks-add />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { toSvg } from "jdenticon";
export default {
    data() {
        return {
        };
    },
    mounted() {
        this.$root.loadBackButtom();
        // const svgString = toSvg("value", 100);
        // console.log(svgString);
    },
    methods: {
    }
}
</script>